module.exports = __webpack_public_path__ + "assets/sentiment_negative.e72fbc71.svg";